import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

export async function listarItems({state, commit}, requestParameters = {params: state.filtro}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('adm_general/listado-item', requestParameters)
        .then((response) => {
            commit('setListarItems', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function crearItem({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http.post('adm_general/item/crear', state.selectedItem)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            commit('resetSelectedItem');
        })
        .catch((error) => {
            let texto = [];

            if (error.errors) {
                const errores = error.errors;
                for (const llave in errores) {
                    if (errores[llave] && errores[llave][0]) {
                        texto.push(errores[llave][0]);
                    }
                }
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                text: texto.join('\n'),
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function mostrarItem({commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http.get(`adm_general/item/mostrar/${id}`)
        .then((response) => {
            commit('setItem', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function actualizarItem({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});

    await $http.put(`adm_general/item/editar/${state.selectedItem.id}`, state.selectedItem)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            dispatch('mostrarItem', state.selectedItem.id);
        }).catch((error) => {
            let texto = [];

            if (error.errors) {
                const errores = error.errors;
                for (const llave in errores) {
                    if (errores[llave] && errores[llave][0]) {
                        texto.push(errores[llave][0]);
                    }
                }
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: texto.join('\n'),
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function desactivarItem({commit, dispatch}, id) {

    await Swal.fire({
        title: 'Cambiar estado',
        text: '¿Está seguro de cambiar el estado del item?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, cambiar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            $http.put(`adm_general/item/inactivar/${id}`)
                .then((response) => {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                    dispatch('listarItems');
                }).catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });

            commit('dashboard/load', false, {root: true});
        }
    });
}

export async function listaTipoSeguimiento({commit, state}) {

    // if (!state.tipoSeguimientos.length) {

        const parametros = {
            params: {
                paginate: false
            }
        };

        await $http.get('adm_general/tipo-seguimiento', parametros)
            .then((response) => {
                commit('setListarTipoSeguimiento', response.data.data);
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    // }
}

// filtro de paginacion
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('listarItems');
}
